import {
  SLRLabelIcon,
  SLRMediaSize,
  SLRMobileNavBar,
  SLRNavBar,
  SLRProfileDropdown,
  getIcon,
  useAuth,
  useGetMediaItem,
  useWindowSize
} from '@slr/shared-library';
import {
  DEFAULT_PROFILE_IMAGE_PATH,
  MOBILE_VIEW_WIDTH,
  PROFILE_PATH
} from 'configs';
import { useIsPlatformAdmin } from 'hooks/admin/useIsPlatformAdmin';
import { useGetCurrentUserProfile } from 'hooks';
import { FC } from 'react';
import { NavDropdown } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router';
import { Logo } from '../../components/Logo';
import useGlobalNavigationItems from './GlobalNavigationItems';

import { globalNavigationConfig } from 'settings';
import './NavBar.scss';

export const NavBar: FC = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const { isAuthenticated, logout, hasClientRole } = useAuth();
  const isOnboardingAdmin = hasClientRole('onboarding', 'mdl');
  const isPlatformAdmin = useIsPlatformAdmin();
  const globalNavigationItems = useGlobalNavigationItems();

  const { isMobileView, width } = useWindowSize(
    isOnboardingAdmin || isPlatformAdmin ? 900 : MOBILE_VIEW_WIDTH
  );

  const { data: user, isPending: isUserLoading } = useGetCurrentUserProfile();
  const { data: profilePicture, isFetching: isUserPictureLoading } =
    useGetMediaItem(user?.pictureId, SLRMediaSize.Small);

  const isLoading = isAuthenticated && (isUserLoading || isUserPictureLoading);

  return (
    <>
      <SLRNavBar
        appLogo={<Logo />}
        appURL={globalNavigationConfig.start}
        navItems={
          isMobileView || !isAuthenticated ? undefined : globalNavigationItems
        }
        navItemsOptions={{
          useIncludesForIsActive: true
        }}
        showToggle={!isMobileView}
        profileDropdown={
          isAuthenticated ? (
            <SLRProfileDropdown
              keepNamesVisible={width > 450}
              isLoading={isLoading}
              lastName={user?.lastName}
              firstName={user?.firstName}
              profilePicture={profilePicture?.url}
              profilePictureFallback={DEFAULT_PROFILE_IMAGE_PATH}
            >
              <NavDropdown.Item
                href={`${globalNavigationConfig.book}/bookings`}
              >
                <SLRLabelIcon
                  icon={getIcon('fas', 'list')}
                  label={t('navBar.bookings')}
                />
              </NavDropdown.Item>
              <NavDropdown.Item
                href={`${globalNavigationConfig.rent}/booking-requests`}
              >
                <SLRLabelIcon
                  icon={getIcon('fas', 'calendar-days')}
                  label={t('navBar.bookingRequests')}
                />
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to={PROFILE_PATH}>
                <SLRLabelIcon
                  icon={getIcon('fas', 'address-card')}
                  label={t('navigation.subdomains.profile')}
                />
              </NavDropdown.Item>
              <NavDropdown.Item onClick={() => logout()}>
                <SLRLabelIcon
                  icon={getIcon('fas', 'right-from-bracket')}
                  label={t('navBar.logout')}
                />
              </NavDropdown.Item>
            </SLRProfileDropdown>
          ) : undefined
        }
        currentPath={pathname}
      />
      {isAuthenticated && isMobileView && (
        <SLRMobileNavBar
          navItems={globalNavigationItems}
          navItemsOptions={{
            isIconVisible: true,
            useIncludesForIsActive: true
          }}
          currentPath={pathname}
        />
      )}
    </>
  );
};
